module.exports = __webpack_public_path__ + "img/MEDIA066.23e6c637.jpg";